import StartPageView from "./StartPageView";

function StartPage() {
  return <StartPageView />;
}

export default StartPage;
